import PolicyPage from "../components/PolicyPage";

export default function Terms() {
  return (
    <PolicyPage
      kind="terms"
      title="Terms of Use — Reading this site responsibly."
      intro="These terms govern your use of drindreshdixit.com. By using the site, you accept these terms. The site is run by Dr. Indresh Dixit's practice in Varanasi for information and patient communication only — it is not a substitute for professional medical care."
      sections={[
        {
          id: "purpose",
          heading: "Purpose of this website",
          body: "This website is published to inform patients about gastroenterology, hepatology and endoscopy services offered by Dr. Indresh Dixit, share educational content, and enable appointment booking through WhatsApp and phone. Nothing on the site constitutes a doctor-patient relationship until you have a confirmed consultation.",
        },
        {
          id: "content-accuracy",
          heading: "Content & accuracy",
          body: "We make reasonable efforts to keep medical content accurate and aligned with current guidelines. Medical practice evolves continuously — content may not reflect the very latest research. Always use this site as a starting point for a conversation with your doctor, not as a replacement for one.",
        },
        {
          id: "intellectual-property",
          heading: "Intellectual property",
          body: "All text, images, video stills and design on this website are © Dr. Indresh Dixit unless otherwise indicated. You may share links to pages freely, but reproducing content (in whole or substantial part) on other sites, marketing material or AI training datasets is not permitted without written permission.",
        },
        {
          id: "external-links",
          heading: "External links",
          body: "We may link to third-party sites (YouTube, Google Maps, peer-reviewed journals) where they add context. We do not control their content and are not responsible for what they show.",
        },
        {
          id: "booking-cancellation",
          heading: "Appointments & cancellations",
          bullets: [
            "Confirmed slots are held for the patient — please cancel as early as possible if you cannot attend, so the slot can be released.",
            "Walk-ins are welcome but booked patients are seen first.",
            "Consultation fees are payable on the day of visit (cash/UPI). For inpatient procedures, billing follows the partner hospital's policy.",
          ],
        },
        {
          id: "changes",
          heading: "Changes to these terms",
          body: "These terms may be updated occasionally. The 'last updated' date at the top reflects the most recent revision. Continuing to use the site after a change means you accept the updated terms.",
        },
      ]}
    />
  );
}
